/*!
 * Copyright (c) 2019 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _regeneratorRuntime = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/inherits");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var forge = require('node-forge');

var base58 = forge.util.binary.base58;

var _require = require('crypto-ld'),
    LDKeyPair = _require.LDKeyPair;

var _require2 = require('crypto-ld/lib/util'),
    base58Decode = _require2.base58Decode;

var ed2curve = require('ed2curve');

var nacl = require('tweetnacl');

var X25519KeyPair =
/*#__PURE__*/
function (_LDKeyPair) {
  _inherits(X25519KeyPair, _LDKeyPair);

  /**
   * An implementation of x25519
   * [X25519 Key Agreement 2019]{@link https://w3c-dvcg.github.io/}
   * representation
   * @example
   * > const privateKeyBase58 =
   *   '...';
   * > const options = {
   *   publicKeyBase58: '...',
   *   privateKeyBase58
   * };
   * > const DHKey = new X25519KeyPair(options);
   * > DHKey
   * X25519KeyPair { ...
   * @param {KeyPairOptions} options - Base58 keys plus other options
   * @param {string} options.controller
   * @param {string} options.id
   * @param {string} options.publicKeyBase58 - Base58 encoded Public Key
   * unencoded is 32-bytes.
   * @param {string} options.privateKeyBase58 - Base58 Private Key
   * unencoded is 32-bytes.
   */
  function X25519KeyPair() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, X25519KeyPair);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(X25519KeyPair).call(this, options));
    _this.type = 'X25519KeyAgreementKey2019';
    _this.privateKeyBase58 = options.privateKeyBase58;
    _this.publicKeyBase58 = options.publicKeyBase58;
    return _this;
  }
  /**
   * Returns the Base58 encoded public key.
   * @implements {LDKeyPair#publicKey}
   * @readonly
   *
   * @returns {string} The Base58 encoded public key.
   */


  _createClass(X25519KeyPair, [{
    key: "addEncodedPublicKey",

    /**
     * Adds a public key base to a public key node.
     * @example
     * > keyPair.addEncodedPublicKey({});
     * { publicKeyBase58: 'GycSSui454dpYRKiFdsQ5uaE8Gy3ac6dSMPcAoQsk8yq' }
     * @param {Object} publicKeyNode - The public key node
     * @param {string} publicKeyNode.publicKeyBase58 - Base58 Public Key
     *
     * @returns {{verify: Function}} A PublicKeyNode in a block.
     */
    value: function addEncodedPublicKey(publicKeyNode) {
      publicKeyNode.publicKeyBase58 = this.publicKeyBase58;
      return publicKeyNode;
    }
    /**
     * Generates and returns a multiformats encoded
     * X25519 public key fingerprint (for use with cryptonyms, for example).
     * @see https://github.com/multiformats/multicodec
     *
     * @param {string} publicKeyBase58 - The base58 encoded public key material.
     *
     * @returns {string} The fingerprint.
     */

  }, {
    key: "deriveSecret",

    /**
     * Derives a shared secret via a given public key, typically for use
     * as one parameter for computing a shared key. It should not be used as
     * a shared key itself, but rather input into a key derivation function (KDF)
     * to produce a shared key.
     * @param {LDKeyPair} publicKey - Remote key pair
     * @throws {TypeError} On invalid base58 encoding of public or private keys
     * @returns {String}
     */
    value: function deriveSecret(_ref) {
      var publicKey = _ref.publicKey;
      var remotePubkeyBytes = base58Decode({
        decode: base58.decode,
        keyMaterial: publicKey.publicKeyBase58,
        type: 'public'
      });
      var privateKeyBytes = base58Decode({
        decode: base58.decode,
        keyMaterial: this.privateKeyBase58,
        type: 'private'
      });
      return nacl.scalarMult(privateKeyBytes, remotePubkeyBytes);
    }
    /**
     * Generates and returns a multiformats encoded
     * X25519 public key fingerprint (for use with cryptonyms, for example).
     * @see https://github.com/multiformats/multicodec
     *
     * @returns {string} The fingerprint.
     */

  }, {
    key: "fingerprint",
    value: function fingerprint() {
      var publicKeyBase58 = this.publicKeyBase58;
      return X25519KeyPair.fingerprintFromPublicKey({
        publicKeyBase58: publicKeyBase58
      });
    }
    /**
     * Tests whether the fingerprint was generated from a given key pair.
     * @example
     * > xKeyPair.verifyFingerprint('...');
     * {valid: true};
     * @param {string} fingerprint - A Base58 public key.
     *
     * @returns {Object} An object indicating valid is true or false.
     */

  }, {
    key: "verifyFingerprint",
    value: function verifyFingerprint(fingerprint) {
      // fingerprint should have `z` prefix indicating
      // that it's multi-base encoded
      if (!(typeof fingerprint === 'string' && fingerprint[0] === 'z')) {
        return {
          error: new Error('`fingerprint` must be a multibase encoded string.'),
          valid: false
        };
      }

      var fingerprintBuffer;

      try {
        fingerprintBuffer = base58Decode({
          decode: base58.decode,
          keyMaterial: fingerprint.slice(1),
          type: "fingerprint's"
        });
      } catch (e) {
        return {
          error: e,
          valid: false
        };
      }

      var publicKeyBuffer;

      try {
        publicKeyBuffer = base58Decode({
          decode: base58.decode,
          keyMaterial: this.publicKeyBase58,
          type: 'public'
        });
      } catch (e) {
        return {
          error: e,
          valid: false
        };
      } // validate the first multicodec byte 0x25


      var valid = fingerprintBuffer[0] === 0x25 && publicKeyBuffer.equals(fingerprintBuffer.slice(1));

      if (!valid) {
        return {
          error: new Error('The fingerprint does not match the public key.'),
          valid: false
        };
      }

      return {
        valid: valid
      };
    }
  }, {
    key: "publicKey",
    get: function get() {
      return this.publicKeyBase58;
    }
    /**
     * Returns the Base58 encoded private key.
     * @implements {LDKeyPair#privateKey}
     * @readonly
     *
     * @returns {string} The Base58 encoded private key.
     */

  }, {
    key: "privateKey",
    get: function get() {
      return this.privateKeyBase58;
    }
    /**
     * Generates a new public/private X25519 Key Pair.
     * Note: This is async only to match the async signature of other LDKeyPair
     * subclasses.
     * @example
     * > const keyPair = await X25519KeyPair.generate();
     * > keyPair
     * X25519KeyPair { ...
     * @param {KeyPairOptions} [options={}]
     * @param {string} [options.controller]
     * @param {string} [options.id]
     *
     * @returns {Promise<X25519KeyPair>} Generates a key pair.
     */

  }], [{
    key: "generate",
    value: function () {
      var _generate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var options,
            _nacl$box$keyPair,
            publicKey,
            privateKey,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                // Each is a Uint8Array with 32-byte key
                _nacl$box$keyPair = nacl.box.keyPair(), publicKey = _nacl$box$keyPair.publicKey, privateKey = _nacl$box$keyPair.secretKey;
                return _context.abrupt("return", new X25519KeyPair(_objectSpread({
                  publicKeyBase58: base58.encode(publicKey),
                  privateKeyBase58: base58.encode(privateKey)
                }, options)));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function generate() {
        return _generate.apply(this, arguments);
      }

      return generate;
    }()
    /**
     * Creates an X25519KeyPair Key Pair from an existing key (constructor
     * method).
     * @example
     * > const options = {
     *   id,
     *   controller,
     *   publicKeyBase58,
     *   privateKeyBase58: privateKey
     * };
     * > const key = await X25519KeyPair.from(options);
     * > key
     * X25519KeyPair { ...
     * @param {Object} options
     * @param {string} [options.privateKeyBase58] - A Base58 encoded Private key
     *
     * @returns {X25519KeyPair} An X25519 Key Pair.
     */

  }, {
    key: "from",
    value: function () {
      var _from = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(options) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new X25519KeyPair(options));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function from(_x) {
        return _from.apply(this, arguments);
      }

      return from;
    }()
  }, {
    key: "fromEdKeyPair",
    value: function fromEdKeyPair(edKeyPair) {
      var xKey = new X25519KeyPair({
        controller: edKeyPair.controller
      });
      xKey.publicKeyBase58 = X25519KeyPair.convertFromEdPublicKey(edKeyPair.publicKeyBase58);

      if (edKeyPair.privateKeyBase58) {
        xKey.privateKeyBase58 = X25519KeyPair.convertFromEdPrivateKey(edKeyPair.privateKeyBase58);
      }

      return xKey;
    }
    /**
     * @param {string} edPublicKeyBase58 - base58 encoded Ed25519 Public key
     *
     * @returns {string} base58 encoded X25519 Public key.
     */

  }, {
    key: "convertFromEdPublicKey",
    value: function convertFromEdPublicKey(edPublicKeyBase58) {
      var edPubkeyBytes = base58Decode({
        decode: base58.decode,
        keyMaterial: edPublicKeyBase58,
        type: 'public'
      }); // Converts a 32-byte Ed25519 public key into a 32-byte Curve25519 key
      // Returns null if the given public key in not a valid Ed25519 public key.

      var dhPubkeyBytes = ed2curve.convertPublicKey(edPubkeyBytes);

      if (!dhPubkeyBytes) {
        throw new Error('Error converting to X25519; Invalid Ed25519 public key.');
      }

      var dhPublicKeyBase58 = base58.encode(dhPubkeyBytes);
      return dhPublicKeyBase58;
    }
    /**
     * @param {string} edPrivateKeyBase58 - base58 encoded Ed25519 Private key
     *
     * @returns {string} base58 encoded X25519 Private key.
     */

  }, {
    key: "convertFromEdPrivateKey",
    value: function convertFromEdPrivateKey(edPrivateKeyBase58) {
      var edPrivkeyBytes = base58Decode({
        decode: base58.decode,
        keyMaterial: edPrivateKeyBase58,
        type: 'private'
      }); // Converts a 64-byte Ed25519 secret key (or just the first 32-byte part of
      // it, which is the secret value) into a 32-byte Curve25519 secret key

      var dhPrivkeyBytes = ed2curve.convertSecretKey(edPrivkeyBytes);

      if (!dhPrivkeyBytes) {
        throw new Error('Error converting to X25519; Invalid Ed25519 private key.');
      }

      var dhPrivateKeyBase58 = base58.encode(dhPrivkeyBytes);
      return dhPrivateKeyBase58;
    }
  }, {
    key: "fingerprintFromPublicKey",
    value: function fingerprintFromPublicKey(_ref2) {
      var publicKeyBase58 = _ref2.publicKeyBase58;
      // X25519 cryptonyms are multicodec encoded values, specifically:
      // (multicodec x25519-pub 0x25 + key bytes)
      var pubkeyBytes = base58Decode({
        decode: base58.decode,
        keyMaterial: publicKeyBase58,
        type: 'public'
      });
      var buffer = new Uint8Array(1 + pubkeyBytes.length);
      buffer[0] = 0x25;
      buffer.set(pubkeyBytes, 1); // prefix with `z` to indicate multi-base base58btc encoding

      return "z".concat(base58.encode(buffer));
    }
    /**
     * Creates an instance of X25519KeyPair from a key fingerprint.
     *
     * @param {string} fingerprint
     * @returns {X25519KeyPair}
     * @throws Unsupported Fingerprint Type.
     */

  }, {
    key: "fromFingerprint",
    value: function fromFingerprint(_ref3) {
      var fingerprint = _ref3.fingerprint;
      // skip leading `z` that indicates base58 encoding
      var buffer = base58.decode(fingerprint.substr(1)); // buffer is: 0x25 <public key bytes>

      if (buffer[0] !== 0x25) {
        throw new Error("Unsupported Fingerprint Type: ".concat(fingerprint));
      }

      return new X25519KeyPair({
        publicKeyBase58: base58.encode(buffer.slice(1))
      });
    }
  }]);

  return X25519KeyPair;
}(LDKeyPair);

module.exports = X25519KeyPair;